import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;
const TOKEN_EXPIRY = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

const authService = {
  // Admin login - only for admins
  adminLogin: async (credentials) => {
    try {
      // console.log('Attempting admin login...', API_URL);
      const response = await axios.post(`${API_URL}/auth/admin/login`, credentials);

      if (response?.data?.success && response?.data?.user?.role == 'admin' 
        && response?.data?.token != null) {
        
          // Store admin auth data
        // console.log(response.data.token);
        localStorage.setItem('adminToken', response.data.token);
        localStorage.setItem('admin', JSON.stringify(response.data.user));
        localStorage.setItem('adminTokenExpiry', Date.now() + TOKEN_EXPIRY);        
        return response;
      }else{
        throw new Error('Invalid request or not authorised');
      }
    } catch (error) {
      console.error('Admin login failed:', error);
      throw error;
    }
  },

  // Brand login - FIXED
  brandLogin: async (credentials) => {
    try {
      // console.log('Attempting brand login with:', credentials.email);
      // Use the correct endpoint for brand login
      const response = await axios.post(`${API_URL}/brand/login`, credentials);

      if (response.data.success) {
        // Store brand auth data - use the correct structure
        const { brand, token } = response.data.data;

        localStorage.setItem('brandToken', token);
        localStorage.setItem('brandCode', brand.brandCode);
        localStorage.setItem('brandName', brand.brandName);
        localStorage.setItem('brand', JSON.stringify(brand));
        localStorage.setItem('brandTokenExpiry', Date.now() + TOKEN_EXPIRY);

        // console.log('Brand login successful for:', brand.brandCode);
        return response;
      }
    } catch (error) {
      console.error('Brand login failed:', error);
      throw error;
    }
  },

  // Logout for admin or brand
  logout: (userType = 'brand') => {
    if (userType === 'admin') {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('admin');
      localStorage.removeItem('adminTokenExpiry');
      window.location.href = '/admin-login';
    } else {
      localStorage.removeItem('brandToken');
      localStorage.removeItem('brandCode');
      localStorage.removeItem('brandName');
      localStorage.removeItem('brand');
      localStorage.removeItem('brandTokenExpiry');
      window.location.href = '/';
    }
  },

  // Check if user is authenticated
  isAuthenticated: (userType = 'brand') => {
    const token = localStorage.getItem(userType === 'admin' ? 'adminToken' : 'brandToken');
    const expiryTime = localStorage.getItem(userType === 'admin' ? 'adminTokenExpiry' : 'brandTokenExpiry');

    if (!token || !expiryTime) return false;

    if (Number(expiryTime) < Date.now()) {
      authService.logout(userType); // Auto logout on expiry
      return false;
    }

    return true;
  },

  // Get current user
  getCurrentUser: (userType = 'brand') => {
    const userStr = localStorage.getItem(userType === 'admin' ? 'admin' : 'brand');
    return userStr ? JSON.parse(userStr) : null;
  },

  // Get auth token
  getToken: (userType = 'brand') => {
    return localStorage.getItem(userType === 'admin' ? 'adminToken' : 'brandToken');
  },

  // Refresh token expiration on activity
  refreshTokenExpiry: (userType = 'brand') => {
    const token = localStorage.getItem(userType === 'admin' ? 'adminToken' : 'brandToken');
    if (token) {
      localStorage.setItem(
        userType === 'admin' ? 'adminTokenExpiry' : 'brandTokenExpiry',
        Date.now() + TOKEN_EXPIRY
      );
    }
  }
};

export default authService;
